export const ENTER_WORKTREE_TOOL_NAME = 'EnterWorktree'
